var styles = {"PageWrapper":"styles-module_PageWrapper__wkRd7","Main":"styles-module_Main__GkQU0","IsOpen":"styles-module_IsOpen__k5wSu","Navigation":"styles-module_Navigation__Jn9Z2"};

export { styles as default };
